export const expandableCardMixin = {
    props: {
        expandable: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
}
